import { render, staticRenderFns } from "./cardBox.vue?vue&type=template&id=221d48f2"
import script from "./cardBox.vue?vue&type=script&lang=js"
export * from "./cardBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports